import React, { useState } from "react";
import axios from "axios";
import { Logo } from "../../assets";
import { useHistory } from "react-router-dom";

const Component = () => {
  const history = useHistory();
  const [code, setCode] = useState("");
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const handleCode = (event) => setCode(event.target.value);
  const handleEmail = (event) => setEmail(event.target.value);
  const handleNewPassword = (event) => setNewPassword(event.target.value);
  const urlApiCode = `https://lensapi.elint.services/login/forgot-password/confirm`;
  const handleSubmit = (event) => {
    event.preventDefault();
    const codeJSON = JSON.stringify({
      email: email,
      newPassword: newPassword,
      code: code,
    });
    axios
      .post(urlApiCode, codeJSON)

      .then((res) => {
        history.push("/");
      })
      .catch((error) => {
        console.log(error);
        setMessage("Invalid user");
      });
  };
  return (
    <div className="page__container page-main__container">
      <div className="logo__container">
        <div>
          <div>
            <Logo />
          </div>
          <div className="lens">Lens</div>
        </div>
      </div>
      <div className="main__container">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
          style={{ marginTop: 350 }}
        >
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              onChange={(e) => {
                handleEmail(e);
              }}
            />
            <input
              type="password"
              className="form-control"
              placeholder="New password"
              onChange={(e) => {
                handleNewPassword(e);
              }}
            />
            <input
              type="code"
              className="form-control"
              placeholder="Verification code (check your email)"
              onChange={(e) => {
                handleCode(e);
              }}
            />
            {message && <div className="error">{message}</div>}
          </div>
          <div
            className="buttons__container"
            style={{ justifyContent: "center" }}
          >
            <button type="submit" className="btn color-button btn-block">
              CHANGE PASSWORD
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Component;
